import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #F7FAFC;
  border-radius: 8px;
  padding: 6px 8px;
  height: 40px;
  gap: 8px;
  box-sizing: border-box;
  flex-shrink: 0;
`

export const Text = styled.span`
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #46474A;
  white-space: nowrap;
  flex: 1;
`

export const LabelText = styled.span`
  font-weight: 700;
  color: #46474A;
`

export const IconsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  color: #577285;
  border-radius: 4px;

  &:hover {
    background-color: rgba(87, 114, 133, 0.1);
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
    &:hover {
      background-color: transparent;
    }
  }

  svg {
    width: 20px;
    height: 20px;
  }
`
